module.exports = __webpack_public_path__ + "img/1538173982.c8daea0c.jpg";